<template>
  <v-card
    v-if="Object.entries(ttindeslit).length !== 0 "
    class="justify-start"
    max-width="800"
    flat
  >
    <v-list-item two-line v-if="listManual(3).length !== 0 && false">
      <v-list-item-content>
        <v-list-item-title>
          <span class="font-weight-bold text-uppercase">De Taller</span>
        </v-list-item-title>
        <v-list-item-subtitle>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, i) in listManual(3)" :key="i">
                  <td
                    style="cursor:pointer"
                    class="caption text-uppercase font-weight-normal"
                   @click="descargar(item, 3)"
                  >
             <a>{{ item }}</a>
                   
                   
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line v-if="listManual(2).length !== 0" >
      <v-list-item-content>
        <v-list-item-title>
          <span class="font-weight-bold text-uppercase">De Usuario</span>
        </v-list-item-title>
        <v-list-item-subtitle>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, i) in listManual(2)" :key="i">
                  <td
                    style="cursor:pointer"
                    class="caption text-uppercase font-weight-normal"
                    @click="descargar(item, 2)"
                  >
                     <a>{{ item }}</a>
                  
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item two-line v-if="listManual(1).length !== 0">
      <v-list-item-content>
        <v-list-item-title>
          <span class="font-weight-bold text-uppercase">Despiece</span>
        </v-list-item-title>

        <v-list-item-subtitle>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, i) in listManual(1)" :key="i">
                  <td
                    style="cursor:pointer"
                    class="caption text-uppercase font-weight-normal"
                    @click="descargar(item, 1)"
                  >
                      <a>{{ item }}</a>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: {
    codart: String,
  },
  created() {
    this.cargarDatos(
      this.divi,
      this.depa,
      this.cate,
      this.subcate,
      this.codart
    );
  },
  methods: {
    ...mapActions(["cargarCatalogoWeb"]),
    async descargar(id, tp) {
let dw =(uri, name) =>{
          var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    link.target ="_blank"
    link.click();
   
        }
      let nbFolder =
        tp == 1 ? "Despiece" : tp == 2 ? "ManualUsuario" : "ManualTaller";
      let data = {
        nbfol: nbFolder,
        nbfil: id,
        codart: this.codart,
      };
      let xUrl = `${this.dirTemp}files/getmanual.php`;
      await fetch(xUrl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }) 
      .then((resp) => resp.json())
        .then((resp) => {
          if(resp.estatus==1){
            this.dispo=true
 let dataURI = this.dirTemp + "files/" + nbFolder + "/" + this.codart + "/" + id;
dw(dataURI, id) 
          }
        })
        
  
   
    },
    async cargarDatos(Div, Dep, Cat, Scat, Art) {
      await this.cargarCatalogoWeb({
        div: Div,
        dep: Dep,
        cat: Cat,
        sub: Scat,
        articulo: Art,
      });
    },
  },
  computed: {
    ...mapState(["Articulo", "ttindeslit", "dirTemp"]),

    listManual: function() {
      return function(id) {
        if (Object.entries(this.ttindeslit).length !== 0) {
          let txt;
          txt = this.ttindeslit.map((x) =>
            id == 1
              ? x.ArchivoDespiece
              : id == 2
              ? x.ManualUsuario
              : x.ManualTaller
          );
          let arr = [],
            xarr = [];
          if (txt.lastIndexOf(",")) {
            arr = Object.values(txt)
              .toString()
              .split(",");
          } else {
            arr = txt;
          }
          arr.forEach((e) => {
            if (e !== "") xarr.push(e);
          });
          return xarr;
        }
      };
    },
    divi() {
      let div;
      if (Object.entries(this.Articulo).length !== 0) {
        div = this.Articulo.filter((x) => x.Codigo == this.codart).map(
          (x) => x.CodigoDiv
        )[0];
      }
      return div;
    },
    depa() {
      let dep;
      if (Object.entries(this.Articulo).length !== 0) {
        dep = this.Articulo.filter((x) => x.Codigo == this.codart).map(
          (x) => x.CodigoDep
        )[0];
      }
      return dep;
    },
    cate() {
      let cat;
      if (Object.entries(this.Articulo).length !== 0) {
        cat = this.Articulo.filter((x) => x.Codigo == this.codart).map(
          (x) => x.Categoria
        )[0];
      }
      return cat;
    },
    subcate() {
      let scat;
      if (Object.entries(this.Articulo).length !== 0) {
        scat = this.Articulo.filter((x) => x.Codigo == this.codart).map(
          (x) => x.SubCategoria
        );
      }
      return scat;
    },
  },
  data() {
    return {
      
      recent: [
        {
          active: true,
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          title: "Manualll XCXCC",
        },
      ],
      previous: [
        {
          title: "Un File mas",
          avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
        },
      ],
    };
  },
};
</script>

<style></style>
